import React from 'react';
import Hero from '../components/Hero';
import ContactForm from '../components/ContactForm';
import { Mail, MapPin, Clock } from 'lucide-react';
const Contact = () => {
  return <div className="w-full" data-id="element-110">
      {/* Hero Section */}
      <Hero title="Contact Us" subtitle="We would love to hear from you" data-id="element-111" />
      {/* Main Content */}
      <section className="py-16 md:py-24" data-id="element-112">
        <div className="container mx-auto px-4" data-id="element-113">
          <div className="max-w-5xl mx-auto" data-id="element-114">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-115">
              <div data-id="element-116">
                <h2 className="text-3xl font-serif mb-6 text-[#1a2542]" data-id="element-117">
                  Get in Touch
                </h2>
                <p className="text-gray-700 mb-8" data-id="element-118">
                  Whether you are exploring opportunities, resolving a
                  transaction, or expanding across borders, our team is ready to
                  support you.
                </p>
                <div className="space-y-6" data-id="element-119">
                  <div className="flex items-start" data-id="element-120">
                    <div className="bg-[#c8a951]/10 p-3 rounded-full mr-4" data-id="element-121">
                      <Mail size={20} className="text-[#c8a951]" data-id="element-122" />
                    </div>
                    <div data-id="element-123">
                      <h3 className="text-lg font-medium text-[#1a2542] mb-1" data-id="element-124">
                        Email
                      </h3>
                      <a href="mailto:clientaffairs@tclawyering.com" className="text-gray-600 hover:text-[#c8a951] transition-colors duration-300" data-id="element-125">
                        clientaffairs@tclawyering.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-126">
                    <div className="bg-[#c8a951]/10 p-3 rounded-full mr-4" data-id="element-127">
                      <MapPin size={20} className="text-[#c8a951]" data-id="element-128" />
                    </div>
                    <div data-id="element-129">
                      <h3 className="text-lg font-medium text-[#1a2542] mb-1" data-id="element-130">
                        Headquarters
                      </h3>
                      <p className="text-gray-600" data-id="element-131">Lagos, Nigeria</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-132">
                    <div className="bg-[#c8a951]/10 p-3 rounded-full mr-4" data-id="element-133">
                      <Clock size={20} className="text-[#c8a951]" data-id="element-134" />
                    </div>
                    <div data-id="element-135">
                      <h3 className="text-lg font-medium text-[#1a2542] mb-1" data-id="element-136">
                        Business Hours
                      </h3>
                      <p className="text-gray-600" data-id="element-137">
                        Monday – Friday: 9:00 AM – 5:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-138">
                <ContactForm data-id="element-139" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-140">
        <div className="container mx-auto px-4" data-id="element-141">
          <div className="max-w-4xl mx-auto" data-id="element-142">
            <h2 className="text-3xl font-serif mb-8 text-[#1a2542] text-center" data-id="element-143">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6" data-id="element-144">
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-145">
                <h3 className="text-lg font-medium text-[#1a2542] mb-2" data-id="element-146">
                  How quickly can I expect a response after contacting you?
                </h3>
                <p className="text-gray-600" data-id="element-147">
                  We typically respond to all inquiries within 24 business
                  hours. For urgent matters, please indicate so in your message.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-148">
                <h3 className="text-lg font-medium text-[#1a2542] mb-2" data-id="element-149">
                  Do you work with clients internationally?
                </h3>
                <p className="text-gray-600" data-id="element-150">
                  Yes, we have extensive experience working with international
                  clients, particularly those looking to expand into the US,
                  Qatar, and various African markets.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-151">
                <h3 className="text-lg font-medium text-[#1a2542] mb-2" data-id="element-152">
                  What information should I prepare before our first
                  consultation?
                </h3>
                <p className="text-gray-600" data-id="element-153">
                  To make our initial discussion most productive, please prepare
                  a brief overview of your business, the specific legal needs or
                  challenges you're facing, and any relevant timeline
                  considerations.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-154">
                <h3 className="text-lg font-medium text-[#1a2542] mb-2" data-id="element-155">
                  How do you structure your fees?
                </h3>
                <p className="text-gray-600" data-id="element-156">
                  We offer flexible fee arrangements tailored to the nature and
                  scope of each engagement. This may include fixed fees, hourly
                  rates, or retainer arrangements. We'll discuss the most
                  appropriate structure during our initial consultation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Contact;